import React from 'react';
import './link.less';

export interface LinkLabelProps {
	/** set LinkLabel id */
	id?: string;
	/** set text */
	text?: string;
	/** set icon */
	icon?: string;
	/** set url */
	urlLink?: string;
	/** set className to custom design */
	className?: string;
	/** set target */
	target?: string;
	/** set underline */
	hasUnderline?: boolean;
	/** set appearance */
	hasAppearance?: boolean;
	/** set event to be handle when LinkLabel is clicked */
	onClick?(): void;
	/** set event to be handle when LinkLabel on mouse enter label */
	onMouseEnter?(): void;
	/** set event to be handle when LinkLabel on mouse leave label */
	onMouseLeave?(): void;
}

/*
[COMPONENT USAGE]
<LinkLabel
	className="ds-text-link"
	text={t<string>('general.button.continue')}
	icon="ic-show-before"
	urlLink="https://www.google.pt/"
	target="_blank"
	hasAppearance
/>
*/
export const LinkLabel: React.FC<LinkLabelProps> = (props: LinkLabelProps): JSX.Element => {
	const {
		id,
		className,
		text,
		icon,
		urlLink,
		target,
		onClick,
		hasUnderline,
		hasAppearance,
		onMouseEnter,
		onMouseLeave,
	} = props;

	return (
		<div className="it-link-label">
			<a
				id={id}
				className={
					className &&
					`${className}${
						hasUnderline && hasAppearance
							? '-underline ds-text-link-appearance-2'
							: hasUnderline
							? '-underline'
							: hasAppearance
							? '-appearance-2'
							: ''
					}
					${icon ? icon : ''}`
				}
				href={urlLink}
				target={target}
				onClick={onClick}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
			>
				{text}
			</a>
		</div>
	);
};
